// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__R_wRS","additionalInfo":"AgreementModal_additionalInfo__2qyks"};